// @ts-ignore
import * as Yup from 'yup';
import { TranslationService } from '../../../../../../core/services';
import DateTimeParser from '../../../../../../core/utils/DateTimeParser';

export const validationSchema = () => {
    return Yup.object().shape({
        installmentAmount: Yup.number()
            .typeError(TranslationService.translate('FieldOnlyDigits'))
            .min(Yup.ref('minInstallmentAmount'), (obj) => {
                return TranslationService.translate('MinInstalAmount').replace('{0}', obj.min.toString());
            })
            .required(TranslationService.translate('RequiredField')),
        startDate: Yup.string()
            .required(TranslationService.translate('RequiredField'))
            .test(
                'isValidFormat',
                TranslationService.translate('InvalidDateFormat'),
                (value: string | undefined) => {
                    if (value) {
                        return DateTimeParser.isValidFormat(value, 'L');
                    }

                    return false;
                }
            )
            .test('isAfter', TranslationService.translate('MinStartDate'), (value: string | undefined) => {
                if (value) {
                    return DateTimeParser.isAfter(DateTimeParser.addDays(1));
                }

                return false;
            }),
        showPlanTypes: Yup.boolean(),
        installmentPlanTypes: Yup.string().when('showPlanTypes', {
            is: (showPlanTypes: boolean) => {
                return showPlanTypes;
            },
            then: Yup.string()
                .typeError(TranslationService.translate('RequiredField'))
                .required(TranslationService.translate('RequiredField')),
        })
    })
};
